import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { HeaderService } from '@app/modules/header/header.service';
import { SharedModule } from '@app/shared/shared.module';
import { HeaderComponent } from '@app/modules/header/components/header/header.component';
import { DomEventsModule } from '@app/modules/ui/dom-events/dom-events.module';
import { AvatarModule } from '@app/modules/ui/avatar/avatar.module';
import { StreamModule } from '@app/modules/stream/stream.module';
import { UIRouterModule } from '@uirouter/angular';
import { AppInfiniteScrollModule } from '@app/modules/ui/infinite-scroll/infinite-scroll.module';
import { PublicHeaderComponent } from '@app/modules/header/components/public-header/public-header.component';
import { DashboardDropdownsComponent } from '@app/modules/header/components/dashboard-dropdowns/dashboard-dropdowns.component';

@NgModule({
  imports: [SharedModule, DomEventsModule, AvatarModule, StreamModule, UIRouterModule, AppInfiniteScrollModule],
  declarations: [DashboardDropdownsComponent, HeaderComponent, PublicHeaderComponent],
  providers: [HeaderService],
  exports: [DashboardDropdownsComponent, HeaderComponent, PublicHeaderComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class HeaderModule {}
